import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { VideoDetailsType } from 'types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { useLocation, useParams } from 'react-router-dom'
import * as actions from 'member-actions'
import { selectors } from 'member-reducer'
import { Button, Spinner } from 'lp-components'
import { VideoErrorMessage, VideoPlayer } from 'member-portal/components'
import { wpApi } from 'api'
import { makePath, PATH } from 'config'
import { parseQuery } from 'utils'

const propTypes = {
  videoDetails: VideoDetailsType,
  setVideoDetails: PropTypes.func.isRequired,
}

function MobileVideoContent({ videoDetails, setVideoDetails }) {
  const [errorType, setErrorType] = useState(null)
  const [isLoading, setIsLoading] = useState(false)

  const { search } = useLocation()
  const { videoID } = useParams()
  const { sid: authToken } = parseQuery(search)

  useEffect(() => {
    if (videoID && !videoDetails.id) {
      const getVideoDetails = async () => {
        setIsLoading(true)
        try {
          const videoDetails = await wpApi(`videos/${videoID}`)
          setVideoDetails(videoDetails)
        } catch {
          setErrorType('error')
        } finally {
          setIsLoading(false)
        }
      }

      getVideoDetails()
    }
  }, [videoID, videoDetails, setVideoDetails])

  if (errorType) {
    return (
      <section className="form-block-container">
        <VideoErrorMessage type={errorType} />
      </section>
    )
  }
  
  if (isLoading || !videoDetails.id) return <Spinner />

  const {
    is_private: isPrivate = false,
    video_uid: videoUid = '',
    categories = [],
    title = '',
    image_url: imageUrl = '',
    long_description: longDescription = '',
  } = videoDetails

  return (
    <div className="gated-content">
      <div className="top-block" />
      <section className="form-block-container">
        <div className="banner">
          {categories.map((category) => (
            <span key={category}>{category}</span>
          ))}
          <h2 dangerouslySetInnerHTML={{ __html: title }} />
        </div>
        <VideoPlayer
          authToken={authToken}
          imageUrl={imageUrl}
          isPrivate={isPrivate}
          setErrorType={setErrorType}
          src={videoUid}
        />
        <div
          className="video-body video-description"
          dangerouslySetInnerHTML={{ __html: longDescription }}
        />
        <Button
          className="button-primary-outline"
          onClick={() =>
            window.location.replace(
              `${makePath(PATH.SEATOW, PATH.MOBILE_APP, PATH.VIDEOS)}?sid=${authToken}`,
            )
          }
        >
          Back to Videos
        </Button>
      </section>
    </div>
  )
}

MobileVideoContent.propTypes = propTypes

function mapStateToProps(state) {
  return {
    videoDetails: selectors.videoDetails(state),
  }
}

const mapDispatchToProps = {
  setVideoDetails: actions.setVideoDetails,
}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  MobileVideoContent,
)
